import { AUTH_API_BASE } from '../config/api';

// /authenticate verifica access_app no servidor. /admauthenticate é exclusivo do painel.
export async function authenticateApp(email, senha) {
  const response = await fetch(`${AUTH_API_BASE}/authenticate`, {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: email.trim(), senha }),
  });
  const data = await response.json();
  if (data?.error) throw new Error(data.error);
  if (!response.ok) throw new Error('Não foi possível realizar o login. Tente novamente.');
  if (!data?._id || data.access_app !== true) {
    throw new Error('Este usuário não tem acesso ao aplicativo. Solicite a liberação no painel.');
  }
  return data;
}
